<div
  class="gw-w-full gw-max-w-3xl gw-mx-auto gw-max-h-[70vh] gw-overflow-y-auto"
>
  <div class="gw-space-y-4 gw-p-x-large">
    <p class="gw-text-text-primary gw-text-base">
      {{
        'features.settings.parameters.providerSettingsOverrides.description'
          | translate
      }}
    </p>

    <section class="gw-space-y-2">
      <h3 class="gw-text-sm gw-font-medium gw-text-text-primary">
        {{
          'features.settings.parameters.providerSettingsOverrides.configuredProviders'
            | translate
        }}
      </h3>
      <p
        *ngIf="configuredProviders.length === 0"
        class="gw-text-sm gw-text-text-secondary"
      >
        {{
          'features.settings.parameters.providerSettingsOverrides.noProvidersConfigured'
            | translate
        }}
      </p>
      <ul
        *ngIf="configuredProviders.length > 0"
        class="gw-space-y-2 gw-list-none"
      >
        <li
          *ngFor="let p of configuredProviders"
          class="gw-flex gw-flex-wrap gw-items-center gw-gap-2 gw-p-2 gw-rounded-md gw-bg-background-elevation-1"
        >
          <span class="gw-font-medium gw-uppercase gw-text-sm">{{ p }}</span>
          <button
            type="button"
            class="gw-text-sm gw-text-primary gw-underline"
            (click)="editProvider(p)"
          >
            {{
              'features.settings.parameters.providerSettingsOverrides.editProvider'
                | translate
            }}
          </button>
          <button
            type="button"
            class="gw-text-sm gw-text-status-negative"
            (click)="removeProvider(p)"
          >
            {{
              'features.settings.parameters.providerSettingsOverrides.removeProvider'
                | translate
            }}
          </button>
        </li>
      </ul>
    </section>

    <section
      *ngIf="addProviderItems.length > 0"
      class="gw-flex gw-flex-wrap gw-gap-3 gw-items-end gw-border gw-border-border-normal gw-rounded-lg gw-p-4"
    >
      <div class="gw-min-w-[200px] gw-flex-1">
        <gatewee-select-v3
          [formControl]="providerToAdd"
          [items]="addProviderItems"
          [label]="
            'features.settings.parameters.providerSettingsOverrides.selectProvider'
              | translate
          "
          inputId="pso-provider-add"
          [placeholder]="
            'features.settings.parameters.providerSettingsOverrides.selectPlaceholder'
              | translate
          "
        ></gatewee-select-v3>
      </div>
      <gatewee-button
        variant="outline"
        type="button"
        [title]="
          'features.settings.parameters.providerSettingsOverrides.addProvider'
            | translate
        "
        (clicked)="addProvider()"
        [disabled]="!providerToAdd.value || submitting"
      ></gatewee-button>
    </section>

    <section
      *ngIf="activeProvider"
      [formGroup]="providerForm"
      class="gw-border gw-border-border-normal gw-rounded-lg gw-p-4 gw-space-y-2"
    >
      <h3
        class="gw-text-sm gw-font-medium gw-text-text-primary gw-uppercase gw-mb-2"
      >
        {{ activeProvider }}
      </h3>
      <label class="gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          formControlName="transactionProxy"
          class="gw-w-5 gw-h-5"
        />
        <span>{{
          'features.settings.parameters.providerSettingsOverrides.transactionProxy'
            | translate
        }}</span>
      </label>
      <label class="gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          formControlName="onboarding"
          class="gw-w-5 gw-h-5"
        />
        <span>{{
          'features.settings.parameters.providerSettingsOverrides.onboarding'
            | translate
        }}</span>
      </label>
      <label class="gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          formControlName="requiresBankAccount"
          class="gw-w-5 gw-h-5"
        />
        <span>{{
          'features.settings.parameters.providerSettingsOverrides.requiresBankAccount'
            | translate
        }}</span>
      </label>
      <label class="gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          formControlName="creditCardAntifraud"
          class="gw-w-5 gw-h-5"
        />
        <span>{{
          'features.settings.parameters.providerSettingsOverrides.creditCardAntifraud'
            | translate
        }}</span>
      </label>
      <gatewee-button
        variant="outline"
        type="button"
        [title]="
          'features.settings.parameters.providerSettingsOverrides.applyProvider'
            | translate
        "
        (clicked)="apply()"
        [disabled]="submitting"
      ></gatewee-button>
    </section>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-pt-4">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="
          'features.settings.parameters.providerSettingsOverrides.send'
            | translate
        "
        type="button"
        (clicked)="onSend()"
        [disabled]="submitting"
      ></gatewee-button>
    </div>
  </div>
</div>
